import { Modal } from "react-bootstrap";
import { URLS } from "../urls";
import TableComponent from "../TableComponent";
import NoTableItem from "../NoTableItem";
import { useCallback, useEffect, useState } from "react";
import { fetchActionsUtil, useCookie } from "../../utils";
import { toast } from "react-toastify";
import ModalLoader from "../ModalLoader";
import moment from "moment";
import { Button, OverlayTrigger, Popover, Table } from "react-bootstrap";

const DisplayUsers = ({ users, open, close, leave }) => {
  const branch_id = useCookie("branch_id");

  const [loading, setLoading] = useState(false);
  const [leaveBalanceId, setLeaveBalanceId] = useState("");
  const [days, setDays] = useState(0);
  const [tableData, setTableData] = useState([]);

  const getBalance = useCallback(async () => {
    try {
      setLoading(true);
      const res = await fetchActionsUtil(
        `${URLS.backendLeaveBalances}/get-normal-leaveBalances?branch_id=${branch_id}`
      );

      const { leaveBalances, employees } = res;

      let allUsers = [];

      for (let index = 0; index < leaveBalances?.length; index++) {
        const balance = leaveBalances[index];

        for (let index = 0; index < users?.length; index++) {
          const user = users[index];

          if (balance?._id === user?._id) {
            const availableLeaveIndex = balance.leavesAvailable.findIndex(
              (obj) => `${obj._id}` === `${leave?._id}`
            );

            const employee = employees?.find((el) => el._id === user?._id);

            const joinDate = employee?.jobInfo?.joinDate;

            const monthsWorked = moment().diff(
              moment(joinDate, "DD/MM/YYYY"),
              "months"
            );

            const days =
              balance.leavesAvailable[availableLeaveIndex][
                "neverExpireTotal"
              ] || 0;

            const ann = {
              ...user,
              days,
              addOpeningBalance: monthsWorked >= 12 ? false : true,
            };

            allUsers.push(ann);
          }
        }
      }

      setTableData(allUsers);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }, [users, branch_id, leave?._id]);

  useEffect(() => {
    getBalance();
  }, [getBalance]);

  const handleInputChange = ({ index, value }) => {
    const oldTableData = tableData;
    oldTableData[index]["days"] = value;

    setDays(value);
    setTableData([...oldTableData]);
  };

  const saveOpeningBalance = async () => {
    try {
      setLoading(true);

      await fetchActionsUtil(
        `${URLS.backendLeaveBalances}/opening-balance`,
        "POST",
        "",
        { leaveId: leave?._id, leaveBalanceId, days }
      );
      toast.success("Successful");
    } catch (error) {
      console.log(error);
      toast.error(error?.message);
    } finally {
      setLoading(false);
    }
  };

  const tableHead = () => {
    return (
      <thead className="table">
        <tr>
          <th className="text-center">S/N</th>
          <th className="text-center">Name</th>
          <th className="text-center">
            Opening Balance <MessagePopOver />
          </th>
        </tr>
      </thead>
    );
  };

  const tableBody = (user, index) => {
    return (
      <>
        <td className="text-center">{index + 1}</td>
        <td className="text-center">
          <div>
            <span className="avatar">
              <img
                alt=""
                src={
                  user?.image
                    ? URLS.backendStatic + "/" + user?.image
                    : "/assets/img/profiles/avatar-02.jpg"
                }
              />
            </span>

            <div>
              <span>{user?.name}</span>
            </div>
          </div>
        </td>
        <td
          className="text-center"
          onClick={() => setLeaveBalanceId(user?._id)}
        >
          <div className="d-flex align-items-center justify-content-center">
            <input
              type="number"
              name="balance"
              id="balance"
              className="form-control"
              value={user?.days}
              onChange={(e) =>
                handleInputChange({ index, value: e.target.value })
              }
              onKeyDown={(e) => e.keyCode === 13 && saveOpeningBalance()}
              disabled={user?.addOpeningBalance}
            />
            <button
              className="btn btn-primary btn-sm ml-2"
              disabled={user?.addOpeningBalance}
              onClick={saveOpeningBalance}
            >
              <i className="fa fa-floppy-o mr-2"></i>Save
            </button>
          </div>
        </td>
      </>
    );
  };

  return (
    <Modal
      className="custom-modal"
      show={open}
      centered
      onHide={() => {
        close();
      }}
      size="md"
    >
      <Modal.Header closeButton>
        <Modal.Title>
          <h4>Employees</h4>
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="p-3">
          {users?.length > 0 ? (
            <TableComponent
              responsive
              striped
              sticky
              tableHeadsFunction={tableHead}
              mainDataArray={tableData}
              tableDataRowFunction={tableBody}
              className="product-table text-nowrap"
            />
          ) : (
            <NoTableItem />
          )}
        </div>
      </Modal.Body>

      <ModalLoader show={loading} />
    </Modal>
  );
};

export default DisplayUsers;

const MessagePopOver = ({ placement }) => {
  return (
    <OverlayTrigger
      trigger="click"
      rootClose
      placement={placement || "bottom"}
      overlay={
        <Popover>
          <Popover.Title className="text-capitalize text-center">
            <p class="fw-bold">Leave Adjustment Guidelines</p>
          </Popover.Title>
          <Popover.Content as={"div"}>
            <div class="p-3 mb-2 bg-light border rounded h5">
              <p class="mb-1">
                To reduce an employee’s opening leave balance, input the number
                of days as a negative value.
              </p>
              <p class="mb-0">
                For example, entering <code class="fw-bold h4">-3</code> will
                subtract three days from the current opening leave balance.
              </p>
            </div>
          </Popover.Content>
        </Popover>
      }
    >
      <Button
        className="d-inline p-0 border-0  px-2  rounded-circle  d-relative"
        size="sm"
        style={{ transform: `scale(0.7)` }}
      >
        <i className="fa fa-info"></i>
      </Button>
    </OverlayTrigger>
  );
};
